export default __webpack_public_path__ + "static/benefits-6a6fb40fc58c73d3cd253cd8ff7fca52.png";